/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ParcelTrackingNumberVo
 */
export interface ParcelTrackingNumberVo {
    /**
     * 包裹ID
     * @type {number}
     * @memberof ParcelTrackingNumberVo
     */
    parcelId?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof ParcelTrackingNumberVo
     */
    trackingNumber?: string;
    /**
     * 快递状态
     * @type {number}
     * @memberof ParcelTrackingNumberVo
     */
    parcelStatus?: number;
    /**
     * 快递状态名称
     * @type {string}
     * @memberof ParcelTrackingNumberVo
     */
    parcelStatusName?: string;
    /**
     * 是否主单号  0 不是 1 是
     * @type {number}
     * @memberof ParcelTrackingNumberVo
     */
    main?: number;
}

/**
 * Check if a given object implements the ParcelTrackingNumberVo interface.
 */
export function instanceOfParcelTrackingNumberVo(value: object): value is ParcelTrackingNumberVo {
    return true;
}

export function ParcelTrackingNumberVoFromJSON(json: any): ParcelTrackingNumberVo {
    return ParcelTrackingNumberVoFromJSONTyped(json, false);
}

export function ParcelTrackingNumberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParcelTrackingNumberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'parcelId': json['parcelId'] == null ? undefined : json['parcelId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
        'parcelStatus': json['parcelStatus'] == null ? undefined : json['parcelStatus'],
        'parcelStatusName': json['parcelStatusName'] == null ? undefined : json['parcelStatusName'],
        'main': json['main'] == null ? undefined : json['main'],
    };
}

export function ParcelTrackingNumberVoToJSON(json: any): ParcelTrackingNumberVo {
    return ParcelTrackingNumberVoToJSONTyped(json, false);
}

export function ParcelTrackingNumberVoToJSONTyped(value?: ParcelTrackingNumberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'parcelId': value['parcelId'],
        'trackingNumber': value['trackingNumber'],
        'parcelStatus': value['parcelStatus'],
        'parcelStatusName': value['parcelStatusName'],
        'main': value['main'],
    };
}

